{
	"accounts": "Λογαριασμοί",
	"invitations": "Προσκλήσεις",
	"subscribeToFeedback": "Εγγραφείτε στο πρόγραμμα σχολίων",
	"notificationSettings": {
		"title": "Ρυθμίσεις ειδοποιήσεων email",
		"invoicingInformation": "Πληροφορίες τιμολόγησης",
		"declarationProcessingStatus": "Κατάσταση επεξεργασίας δήλωσης",
		"enabled": "Ενεργό",
		"disabled": "Ανενεργό",
		"toast": {
			"success": "Η προτίμηση ειδοποιήσεων ενημερώθηκε",
			"error": "Αποτυχία ενημέρωσης προτίμησης ειδοποιήσεων"
		}
	},
	"about": {
		"title": "Σχετικά",
		"termsAndConditions": "Όροι και Προϋποθέσεις",
		"privacyPolicy": "Πολιτική Απορρήτου",
		"imprint": "Αποτύπωμα",
		"openSourceAttribution": "Αναφορά ανοιχτού κώδικα"
	},
	"language": {
		"title": "Γλώσσα",
		"footer": "Οι αλλαγές γλώσσας θα μεταδοθούν σε όλες τις εφαρμογές Heidelberg Materials"
	},
	"impressum": "Αποτύπωμα",
	"copyright": "© 2024 Heidelberg Materials. Με την επιφύλαξη παντός δικαιώματος.",
	"login": "Σύνδεση",
	"logout": "Αποσύνδεση"
}
